var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.icons),function(icon,index){return _c('span',{key:index,staticClass:"mr-2 p-2",class:[{ 'selected': icon === _vm.currentValue }]},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":icon},on:{"click":function($event){return _vm.iconClicked(icon)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }